// @ts-nocheck
import React from "react";

// Desktop controls for the graph, including time range and dataset toggles
const GraphDesktopControls = ({
  selectedTimeRange,
  timeRanges,
  onOpenTimeRange,
  onOpenDataset,
  extraControls,
  trailingControls = null,
  leftContent = null,
  disabled = false,
  onResetZoom,
  isZoomed = false,
}) => {
  const timeRangeLabel =
    timeRanges.find((option) => option.value === selectedTimeRange)?.label ||
    "24 Hours";

  const containerClasses = [
    "flex flex-row items-center gap-2 mb-1 sm:mb-2",
    leftContent ? "justify-between" : "justify-end sm:justify-end",
  ].join(" ");

  return (
    <div className={containerClasses}>
      {leftContent ? (
        <div className="text-eai-caption text-eai-ink-subtle sm:text-eai-body-xs">{leftContent}</div>
      ) : null}
      <div className="hidden sm:flex gap-1.5 ml-1 sm:ml-0">
        {onResetZoom && isZoomed && (
          <button
            type="button"
            onClick={onResetZoom}
            aria-label="Reset zoom"
            className="eai-btn-toolbar w-eai-control-sm px-0 sm:w-auto sm:px-3"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 8V4m0 0h4M4 4l5 5m11-5v4m0-4h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
              />
            </svg>
            <span className="hidden sm:inline">Reset Zoom</span>
          </button>
        )}
        {extraControls}
        {!disabled && <button
          type="button"
          onClick={onOpenTimeRange}
          aria-label="Select time range"
          className="eai-btn-toolbar"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span className="hidden sm:inline">{timeRangeLabel}</span>
        </button>}
        {!disabled && <button
          type="button"
          onClick={onOpenDataset}
          aria-label="Toggle dataset visibility"
          className="eai-btn-toolbar"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
            />
          </svg>
          <span className="hidden sm:inline">Datasets</span>
        </button>}
        {trailingControls}
      </div>
    </div>
  );
};

export default GraphDesktopControls;
